import { myFunctions } from '../firebase'

// Utility function to convert a Blob to a base64 string
export function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()

    reader.onloadend = () => {
      // Remove the data URL prefix
      const base64String = reader.result.split(',')[1]

      resolve(base64String)
    }
    reader.onerror = reject
    reader.readAsDataURL(blob)
  })
}

// Utility function to convert a base64 string to a Blob
export function base64ToBlob(base64, mimeType) {
  const byteString = atob(base64)
  const arrayBuffer = new ArrayBuffer(byteString.length)
  const uint8Array = new Uint8Array(arrayBuffer)

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i)
  }

  return new Blob([arrayBuffer], { type: mimeType })
}

// Recieves an audio  blob from safari, converts in on the server to a format that can be used by the Whisper API
export const convertSafariAudio = async blob => {
  try {
    console.log('convert safari audio')
    const base64Audio = await blobToBase64(blob)
    const { data } = await myFunctions.convertSafariAudio({
      audio: base64Audio,
    })
    const convertedAudioBase64 = data.audio
    const convertedAudioBlob = base64ToBlob(convertedAudioBase64, 'audio/mp3')

    return convertedAudioBlob
  } catch (error) {
    console.log('convertSafariAudio Error', error)

    return { error: true, message: error.message }
  }
}
